export var DEFAULT_RIPPLE_CLASSNAMES = {
  enter: "rmd-ripple--animating",
  enterActive: "rmd-ripple--scaling",
  enterDone: "rmd-ripple--animating rmd-ripple--scaling",
  exit: "rmd-ripple--animating rmd-ripple--scaling",
  exitActive: "rmd-ripple--fading"
};
export var DEFAULT_RIPPLE_TIMEOUT = {
  enter: 150,
  exit: 300
};